import { render, staticRenderFns } from "./IncidentAuthor.vue?vue&type=template&id=124b722c&scoped=true"
import script from "./IncidentAuthor.vue?vue&type=script&lang=js"
export * from "./IncidentAuthor.vue?vue&type=script&lang=js"
import style0 from "./IncidentAuthor.vue?vue&type=style&index=0&id=124b722c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b722c",
  null
  
)

export default component.exports